import React, { useContext, useEffect } from 'react';
import { Button, Header } from 'semantic-ui-react';
import text_templatesActions from 'actions/text_templates';

import './index.scss';
import { useSelector, useDispatch } from 'react-redux';
import textActions from 'actions/text';
import { STATUS_TYPES, Notification } from 'dyl-components';
import { useController, useFormContext } from 'react-hook-form';
import { TextForm } from 'dyl-components';
import { convertSenderVariables } from 'utils/TextFormUtils';
import uploadActions from 'actions/upload';
import CategorizedTemplates from 'shared/NewTasksTab/subcomponents/CategorizedTemplates';
import { TextingComponentContext } from 'shared/context/TextingComponentProvider';
import RestrictedView from 'shared/RestrictedView';
import { USER_PERMISSIONS } from 'dyl-components';

const MessageEditorContainer = ({ recipientId, isLoadingRecipientDetails, onReadMessages, onReplaceRecipientVariable, isAccount, from, to, disabled }) => {
    const dispatch = useDispatch();

    const isSendingText = useSelector(state => state.text.isSendingText || state.upload.isUploadingFile);
    const isReadingPhones = useSelector(state => state.text.isReadingPhones);
    const isReadingTemplate = useSelector(state => state.text_template.isReadingTemplate);
    const userProfile = useSelector(state => state.user.userProfile);
    const isUnsubscribedFromTexting = useSelector(state => state.text.unsubscribedPhones?.includes(to));
    const {setIsTextFormDirty} = useContext(TextingComponentContext);

    const { control, reset, formState: { isValid, isDirty }, handleSubmit } = useFormContext();
    const {
        field: messageField
    } = useController({
        name: 'message',
        control
    });
    const {
        field: attachmentsField
    } = useController({
        name: 'attachments',
        control
    });

    const brandOptOutStatus = useSelector(state => state.tcr.brandOptOutStatus);
    const onReadTemplate = (templateId) => dispatch(text_templatesActions.getTemplate(templateId));
    const handleSelectTemplateChange = (templateId) => {
        if (templateId) {
            onReadTemplate(templateId)
                .then(({ message, attachments }) => {
                    const formattedMessage = convertSenderVariables(message, userProfile);
                    messageField.onChange({
                        target: {
                            name: messageField.name,
                            value: formattedMessage || ''
                        }
                    });
                    const mappedAttachments = (attachments?.data || []).map(att => ({
                        id: att.file_id,
                        name: att.name,
                        size: att.size,
                        url: att.url,
                        path: att.name
                    }));

                    attachmentsField.onChange({
                        target: {
                            name: attachmentsField.name,
                            value: mappedAttachments
                        }
                    });
                }).catch(error => {
                    console.log(error);
                });
        }
    };

    const handleSendText = async (data) => {
        const message = data.message;
        try {
            const textBody = {
                from,
                to,
                message: onReplaceRecipientVariable(message),
                contact_id: Number(recipientId),
                opt_out_message: data.include_opt_out || false
            };
            const attachments = data.attachments || [];
            const templateAttachments = attachments.filter(att => att.id).map(att => ({ id: att.id, url: att.url }));
            const newAttachments = attachments.filter(att => !att.id);
            const uploadedAttachments = await (async () => {
                if (newAttachments.length) {
                    const files = await dispatch(uploadActions.uploadFiles(newAttachments, 'text', [], recipientId, true));
                    return files.map(file => ({ id: file.id, url: file.url }));
                }
                return [];
            })();
            await dispatch(textActions.sendText({
                ...textBody,
                attachments: [...templateAttachments, ...uploadedAttachments]
            }))
            Notification.alert('Sucessfully sent message!', STATUS_TYPES.SUCCESS);
            onReadMessages(to, from);
            reset({ message: '', to, from_phone: from, attachments: [] });
        } catch (error) {
            console.log(error);
            Notification.alert('Failed to send message', STATUS_TYPES.ERROR);
        }
    };
    const { isReadingCategorizedTemplates} = useSelector(state => state.template_category);

    const loading = isLoadingRecipientDetails || isReadingPhones || isSendingText || isReadingTemplate;

    useEffect(()=>{
        setIsTextFormDirty(isDirty)
    },[isDirty, setIsTextFormDirty])
        
    return (
        <>
            {isUnsubscribedFromTexting && <Header textAlign='center' as='h3'>This recipient opted out from receiving texts.</Header>}
            <TextForm
                textFieldName={messageField.name}
                disabled={disabled || isUnsubscribedFromTexting}
                disableOptOut={!brandOptOutStatus?.use_opt_out}
                infoIconMessage={`The message ‘${brandOptOutStatus?.opt_out_message}’ will be added at the end of your actual message. This affects the total character count below.`}
                additionalCharacters={brandOptOutStatus?.opt_out_message?.length}
                actions={(
                    <RestrictedView type="disabled" userPermission={isAccount ? USER_PERMISSIONS.ACCOUNT_ADD : USER_PERMISSIONS.CONTACTS_ADD}>
                        <Button disabled={!isValid || !isDirty || loading || disabled || isUnsubscribedFromTexting} color='primary' type='button' onClick={handleSubmit(handleSendText)}>Send</Button>
                    </RestrictedView>
            )}
                templateSelector={(
                    <CategorizedTemplates
                        onSelectTemplate={handleSelectTemplateChange}
                        isReadingCategorizedTemplates={isReadingCategorizedTemplates}
                        type='text'
                        disabled={isUnsubscribedFromTexting}
                    />
                )}
                loading={loading}
                attachmentsFieldName={attachmentsField.name}
                rows={7}
                optOutFieldName='include_opt_out'
                isAccount={isAccount}
                onReplaceVariable={(variable) => {
                    if (variable.includes('My')) {
                        return convertSenderVariables(variable, userProfile)
                    }
                    return variable;
                }}
            />
        </>
    );
};

export default MessageEditorContainer;
